module.exports = __webpack_public_path__ + "img/add_btn_icon460.7b8847b1.svg";